import { AppBar, AppBarSection, AppBarSpacer } from "@progress/kendo-react-layout";
import { useState } from "react";
import logoImg from "../../assets/logo-310x79px.png";
import { useUserContext } from "../../hooks/useUserContext";
import { NavMenu } from "./NavMenu";
import NotificationsDisplay from "./NotificationsDisplay";

export const Header = () => {
  const {
    context: {
      activeCompany: { website, subdomain },
    },
  } = useUserContext();

  const imageUrl = `https://azurewebsitetemplates.blob.core.windows.net/${subdomain}/logo_gs.png`;
  const environment = import.meta.env.VITE_TITLE?.trim();

  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const whitelabeledCompanyLogo = website ? (
    <a href={website} target="_blank">
      <img src={imageUrl} onError={handleImageError} alt="Image" style={{ height: 40 }} />
    </a>
  ) : (
    <img src={imageUrl} onError={handleImageError} alt="Image" style={{ height: 40 }} />
  );

  const showWhitelabeledLogo = !imageError && !!subdomain;

  return (
    <>
      <AppBar themeColor="inherit" positionMode="sticky" style={{ zIndex: 99 }}>
        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <AppBarSection>
              <a href="/">
                <img src={logoImg} alt="logo" height={60} />
              </a>
            </AppBarSection>

            {environment && (
              <div
                style={{
                  fontSize: "24px",
                  color: "red",
                }}
              >
                {environment}
              </div>
            )}
            {showWhitelabeledLogo && (
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    borderLeft: "solid 3px gray",
                    marginLeft: 5,
                    paddingLeft: 10,
                    height: 60,
                  }}
                >
                  <div>INTRODUCED BY</div>
                  <div style={{ flexDirection: "column" }}>{whitelabeledCompanyLogo}</div>
                </div>
              </div>
            )}
            <AppBarSpacer />

            <div style={{ display: "flex", alignItems: "baseline" }}>
              <NavMenu />
            </div>
          </div>

          <NotificationsDisplay />
        </div>
      </AppBar>
    </>
  );
};
